/**
 * Team Listing (carousel style): initializes Swiper for the carousel listing style.
 */
import Swiper from 'swiper/bundle';

const BLOCK_SEL = '.team-listing--carousel';
const SWIPER_SEL = '.team-listing__swiper';

function isEditor() {
  return (
    document.body.classList.contains('block-editor-page')
    || document.body.classList.contains('wp-admin')
    || Boolean(document.querySelector('.block-editor-writing-flow'))
  );
}

function equalizeSlideHeights(swiper) {
  swiper.slides.forEach((slide) => {
    slide.style.height = '';
  });

  const maxHeight = Math.max(
    0,
    ...[...swiper.slides].map((slide) => slide.offsetHeight),
  );

  if (maxHeight === 0) {
    return;
  }

  swiper.slides.forEach((slide) => {
    slide.style.height = `${maxHeight}px`;
  });
}

function buildConfig(block, slideCount) {
  const desktop = Math.max(1, Math.min(6, parseInt(block.dataset.slidesPerView || '3', 10)));
  const tablet = Math.min(3, desktop);
  const mobile = Math.min(2, tablet);
  const spaceBetween = Math.max(0, parseInt(block.dataset.spaceBetween || '20', 10));
  const showArrows = block.dataset.showArrows === '1';
  const showDots = block.dataset.showDots === '1';
  const enableAutoplay = block.dataset.enableAutoplay === '1';
  const enableLoop = block.dataset.enableLoop === '1';

  const config = {
    slidesPerView: 1,
    spaceBetween,
    speed: 500,
    grabCursor: true,
    watchOverflow: true,
    loop: enableLoop && slideCount > desktop,
    a11y: { enabled: true },
    breakpoints: {
      480: {
        slidesPerView: mobile,
      },
      768: {
        slidesPerView: tablet,
      },
      1024: {
        slidesPerView: desktop,
      },
    },
    on: {
      init: equalizeSlideHeights,
      resize: equalizeSlideHeights,
      breakpoint: equalizeSlideHeights,
      imagesReady: equalizeSlideHeights,
    },
  };

  if (showArrows && slideCount > 1) {
    config.navigation = {
      nextEl: block.querySelector('.team-listing__nav-btn--next'),
      prevEl: block.querySelector('.team-listing__nav-btn--prev'),
    };
  }

  if (showDots && slideCount > 1) {
    config.pagination = {
      el: block.querySelector('.team-listing__pagination'),
      clickable: true,
    };
  }

  if (enableAutoplay && slideCount > 1) {
    config.autoplay = {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };
  }

  return config;
}

function initBlock(block) {
  if (block.dataset.swiperMounted === 'true') {
    return;
  }

  const swiperEl = block.querySelector(SWIPER_SEL);
  if (!swiperEl) {
    return;
  }

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
  if (slideCount === 0) {
    return;
  }

  new Swiper(swiperEl, buildConfig(block, slideCount));
  block.dataset.swiperMounted = 'true';
}

function initTeamListingCarousels() {
  if (isEditor()) {
    return;
  }

  document.querySelectorAll(BLOCK_SEL).forEach(initBlock);
}

function whenReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    queueMicrotask(fn);
  }
}

whenReady(initTeamListingCarousels);

if (typeof window.acf !== 'undefined') {
  window.acf.addAction('render_block_preview/type=team-listing', initTeamListingCarousels);
  window.acf.addAction('render_block_preview/type=acf/team-listing', initTeamListingCarousels);
}
